<template>
  <div>
    <div class="navBar" id="navBar" @mouseleave="handleCartMouseOut($event)">
      <!--header-->
      <header class="site-header">
        <!-- top nav bar -->
        <div v-if="!isMobile" class="nav_bottom nav_top">
          <ul>
            <li class="user" v-if="!loggedIn" @click="$router.push({path:'/login'})">
              <img src="../assets/img/user_icon.png" alt="">
              <span style="width:148px" class="navusername">{{ $t('signUPLogIn') }}</span>
            </li>
            <li class="user" v-if="loggedIn" @click="navToAccount('orders')" @mouseover="handleMouseIn($event)" @mouseout="handleMouseOut">
              <img src="../assets/img/user_icon.png" alt="">
              <span style="min-width:70px;padding-left:5px;width:auto;" class="navusername">{{ $t('hi') }}, {{this.$store.state.auth.userDetails.FirstName}}</span>
            </li>
            <li class="translation">
              <el-select v-model="$i18n.locale" @change="langChanged($i18n.locale)">
                <el-option
                  v-for="item in language"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </li>
            <li class="translation">
              <el-select v-model="isUSA" @change="locationChanged($event)">
                <el-option
                  v-for="item in location"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </li>
            <div class="account-portal-modal" v-if="showAccountPortal && loggedIn && !isMobile" @mouseout="handleMouseOut" v-bind:style="userIconCoordinate">
              <div class="account-portal-modal-info">
                <div class="arrow"></div>
                <div class="modal-data-container">
                  <h3 class="bubble-node">{{ $t('account') }}</h3>
                  <p class="bubble-node usernameDisplayInBuble" @click="navToAccount('orders')">{{this.$store.state.auth.userDetails.email}}</p>
                  <div class="bubble-node portal-links-container">
                    <div class="bubble-node each-link" @click="navToAccount('orders')">{{ $t('reviewOrder') }}</div>
                    <div class="bubble-node each-link" @click="navToAccount('addresses')">{{ $t('editAddAddress') }}</div>
                    <div class="bubble-node each-link" @click="navToAccount('informations')">{{ $t('accountInformation') }}</div>
                    <div class="bubble-node each-link" @click="navToAccount('friends')">{{ $t('invite') }}</div>
                  </div>
                  <div class="bubble-node logout" @click="signOut">{{ $t('logOut') }}</div>
                </div>
              </div>
            </div>
          </ul>
        </div>
        <!-- top nav bar end -->
        <!-- buttom nav bar -->
        <div class="nav_bottom">
          <div class="logo" @click="$router.push({path:'/'})">
            <img src="../assets/img/logo2x.png" alt="">
          </div>
          <div class="search">
            <div class="searchproducts">
              <el-input class="searchInp" v-model="searchInp" :placeholder="$t('productNameOrNumber')" @keyup.enter.native="searchProduct"></el-input>
            </div>
            <div class="icon-search" @click="searchProduct">
              <img src="../assets/img/search_icon_white.png" alt="Search">
            </div>
          </div>
          <ul>
            <!-- <li class="cart-link" @mouseover="showAccountPortal=false" @mouseleave="handleCartMouseOut($event)" @mouseenter="handleCartMouseOver($event)" @click="postCartItemsAndCheckout($event)"> -->
            <li class="cart-link" @mouseover="showAccountPortal=false" @click="postCartItemsAndCheckout($event)">
              <a href="javascript:void(0);" class="cart-link" @mouseenter="handleCartMouseOver($event)">
                <img src="../assets/img/shopping-bag.png" alt="">
                <div v-show="itemCount>0" class="site-header__cart-count">{{itemCount}}</div>
              </a>
            </li>
          </ul>
        </div>
        <!-- <div class="">
          <el-button
            @click="shareModalOpen = true"
            :disabled="false"
            class="shareBack">
            {{ $t('shareUs') }}
          </el-button>
        </div> -->
        <!-- buttom nav bar end -->
        
        <!-- mobile nav bar -->
        <div class="nav">
          <div class="menu">
            <img src="../assets/img/sidebar-icon.png" @click="phoneNavShow">
          </div>
          <div class="searchlanguages">
            <el-select v-model="$i18n.locale" @change="langChanged($i18n.locale)">
              <el-option
                v-for="item in language"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-input class="searchInp" v-model="searchInp" :placeholder="$t('productNameOrNumber')" @keyup.enter.native="searchProduct"></el-input>
            <div class="icon-search" @click="searchProduct">
                <img src="../assets/img/search_icon.png" alt="Search">
            </div>
          </div>
          <div class="searchTo" @click="searchProduct">
            <img src="../assets/img/search_icon.png" alt="">
          </div>
          <div class="pop" @click="navToAccount('orders')">
            <img src="../assets/img/user_icon.png" alt="">
          </div>
        </div>
        <!-- mobile nav bar end -->
      </header>
      <!--end header-->

      <!-- mobile group drop down -->
      <div :style="this.phoneNav?' transform: translateY(0px);':'transform: translateY(-100%);'"
        class="mobile-nav-wrapper hidden-md-and-up"
        :class="[MunchiesShow?'sub_nav__is_open':'',this.phoneNav?'mobile_nav_wrapper_show':'']"
      >
        <div class="nav_model"></div>
        <div class="leftRight">
          <div class="nav_model" @click="phoneNav = false"></div> 
          <ul class="navLeft">
            <li class="mobile-nav" v-for="(item, index) in allGroups" :key="index" @click="selectClassify(item.ProductGroup_id)">
              <span class="mobile-nav__label" v-if="$i18n.locale=='en'">{{item.Name}}</span>
              <span class="mobile-nav__label" v-if="$i18n.locale=='ch'">{{item.Description}}</span>
              <i class="el-icon-arrow-right"></i>
            </li>
          </ul>
          <div class="navRight" v-show="classright">
            <ul>
              <li v-for="(item,index) in dataListsChild" :key="index" @click="mobileNavGo(item.ProductCategory_id)">
                <div class="img">
                  <img src="../assets/img/step_1.png" alt="">
                </div>
                <span v-if="$i18n.locale=='en'">{{item.Name}}</span>
                <span v-if="$i18n.locale=='ch'">{{item.Description}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- <transition name="slide"> -->
      <!-- modal check zip -->
      <modal1
        v-if="this.showModal"
        @click="checkForClose"
        @close="this.showModal = false"
        header="Where Do We Deliver To?" ></modal1>
      <transition name="unroll">
        <!-- this.cartClicked -->
        <!-- <div class="cart-container" v-if="this.cartClicked" @mouseleave="handleCartMouseOut($event)" @mouseenter="openCart()"> -->
        <div class="cart-container" v-if="this.cartClicked" >
          <div class="flex-wrapper" > 
            <div class="priceInfo">
              <table class="table">
                <!-- logged in -->
                <div v-if="!local">
                  <thead class="thead-container">
                    <tr class="product-container" v-for="(item,index) in this.$store.state.cart.cartProductsList.Sales_Order_Lines" :key="index">
                      <td class="cart__image-wrapper" ><img @click="goToProductDetail(item)" class="table-image" :style="'height: 100px; padding-left: 30px;padding-right: 10px;'" :src="item.Thumbnail" alt=""></td>
                      <td class="cart__meta small--text-left" :style="'font-size: 12px; padding-right: 40px; padding-left: 0px'">
                        <p v-if='$i18n.locale=="en"' class="product-name">{{item.Name}}</p>
                        <p v-if='$i18n.locale=="ch"' class="product-name">{{item.Description}}</p>
                          <p class="unit-price">${{item.UnitPrice.toFixed(2)}}</p>
                      </td>
                      <td class="quantity-container">
                        <div class="qty_input_cart">
                          <div class="button-wrap">
                            <button class="decrement-btn" @click="updateItemCount($event, item)" >-</button>
                            <p class="product-quantity">{{item.Quantity}}</p>
                            <button :disabled="addDisabled" class="increment-btn" @click="throttleAddToCart(item)">+</button>
                          </div>
                          <div class="trash-container">
                            <i v-on:click.prevent="!itemDeletedLoading && deleteItem(item)" class="fa fa-trash-o"  aria-hidden="true"></i>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </thead>
                </div>
                  <!-- logged out -->
                <div v-else >
                <thead class="thead-container">
                  <tr class="product-container" v-for="(item,index) in this.$store.state.cart.cartProductsList" :key="index">
                    <td class="cart__image-wrapper" ><img @click="goToProductDetail(item)" :src="item.Thumbnail" class="table-image" alt=""></td>
                    <td class="cart__meta small--text-left">
                      <p v-if='$i18n.locale=="en"' class="product-name">{{item.Name}}</p>
                      <p v-if='$i18n.locale=="ch"' class="product-name">{{item.Description}}</p>
                        <p class="unit-price">${{item.Price.toFixed(2)}}</p>
                    </td>
                    <td class="quantity-container">
                      <div class="qty_input_cart">
                        <div class="button-wrap">
                          <!-- &lt; -->
                          <button class="decrement-btn" @click="updateItemCount($event, item)"> - </button>
                          <p class="product-quantity">{{item.quantity}}</p>
                          <!-- &gt; -->
                          <button :disabled="addDisabled" class="increment-btn" @click="throttleAddToCart(item)"> + </button>
                        </div>
                        <div :style="'cursor: pointer'">
                          <i v-on:click.prevent="deleteItem(item)" class="fa fa-trash-o" aria-hidden="true"></i>
                        </div>
                      </div>
                    </td>
                    
                  </tr>
                </thead>
                </div>
              </table>
            </div>
            <div class="price-container">
              <div class="price-wrap">
                <span class="price">{{ $t('subtotal') }}({{this.calculateTotalCartQuantity()}} {{ $t('items') }})</span>
                <span class="tax-footnote">{{ $t('taxAndShipping') }}</span>
                <span class="price prices">${{calculateLocalSubtotal()}} </span>
              </div>
              <div class="checkout-container">
                <button @click="postCartItemsAndCheckout($event)" class="btn" >{{ $t('checkOut') }}</button>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <transition name="modal" v-if="groupItemWarningLocal">
        <div class="modal-mask" @click="groupItemWarningLocal = false">
          <div class="modal-wrapper">
            <div class="modal-container3" @click.stop>
               <div class="infoctn">
                <p class="info">{{ $t('groupItemWarning') }}</p>
              </div>
              <div class="btnctn">
                <button @click="goToCheckoutPage" class="btn" >{{ $t('goToCheckout') }}</button>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <transition name="modal" v-if="groupLoginWarningLocal">
        <div class="modal-mask" @click="groupLoginWarningLocal = false">
          <div class="modal-wrapper">
            <div class="modal-container3" @click.stop>
               <div class="infoctn">
                <p class="info">{{ $t('groupLoginWarning') }}</p>
              </div>
              <div class="btnctn">
                <button @click="goToLoginPage" class="btn" >{{ $t('goToLogin') }}</button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    
      <transition name="modal" v-if="shareModalOpen">
        <div class="modal-mask" @click="shareModalOpen = false">
          <div class="modal-wrapper">
            <div class="modal-container2">
              <div class="share-explain">
                <p>{{ $t('shareNavbar') }}</p>
              </div>
              <div>
                <img @click="onClickShareWechat" class="wechat-icon-container" src="../assets/img/wechat_icon.png">
                <ShareNetwork
                  v-for="network in networks"
                  :network="network.network"
                  :key="network.network"
                  :url="sharing.url"
                  :title="sharing.title"
                  :description="sharing.description"
                  :quote="sharing.quote"
                  :hashtags="sharing.hashtags"
                  :twitterUser="sharing.twitterUser"
                  @open="sharingClosed"
                >
                <!-- @open to @closed -->
                  <img class="icon" :src="network.icon" alt />
                </ShareNetwork>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <el-dialog
        :title="$t('wechat_share')"
        :visible.sync="wechatModalOpen"
        class="myWechatDia"
      >
        <share :config="config"></share>    
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Velocity from 'velocity-animate';
import jquery from "jquery";
import Vue from "vue";
import { mapState, mapActions, mapMutations } from 'vuex';
import modal1 from "../view/modal"; 
import VueSocialSharing from "vue-social-sharing";
Vue.use(VueSocialSharing);
import Share from 'vue-social-share'
Vue.use(Share);

import { isUserAuthenticated, setLocalCart, getLocalCart } from '../store/modules/cart';
import fbicon from "../assets/img/facebook_icon.png";
import twittericon from "../assets/img/twitter_icon.png";
import pinteresticon from "../assets/img/pinterest_icon.png";
import whatsappicon from "../assets/img/whatsapp_icon.png";
import lineicon from "../assets/img/line_icon.png";
import wechaticon from "../assets/img/wechat_icon.png";

import dataList from '../assets/classify.json';

var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
let $ = jquery;
import _ from 'lodash';
export default {
  name: "navbar",
  components: {
    modal1,
  },
  props: {
    group: {
      type: String,
      default: 'munchies'
    }
  },
  data() {
    return {
      shareModalOpen: false,
      wechatModalOpen: false,
      sharing: {
        url: "https://www.newbiotechcorp.com",
        title: "This is the Title.",
        description: "This is the Description.",
        quote: "This is the Quote.",
        hashtags: "New Biotech,hashtag,test",
        twitterUser: "",
      },
      networks: [
        {
          network: "facebook",
          name: "Facebook",
          icon: fbicon,
        },
        {
          network: "twitter",
          name: "Twitter",
          icon: twittericon,
        },
        {
          network: "pinterest",
          name: "Pinterest",
          icon: pinteresticon,
        },
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: whatsappicon,
        },
        {
          network: "line",
          name: "Line",
          icon: lineicon,
        },
      ],
      config: {
        url: 'https://www.newbiotechcorp.com',
        title: 'New Biotech',
        description: 'New Biotech',
        sites: ['wechat'],
        wechatQrcodeTitle: "",
        wechatQrcodeHelper: "",
      },

      dataListsChild:[],
      classright:false,

      language:[{
        value:'ch',
        label:'中文',
      },{
        value:'en',
        label:'English',
      }],
      isUSA: (localStorage.getItem('isUSA')==='true') ? 'USA' : 'None USA',
      location:[{
        value: true,
        label:'USA',
      },{
        value: false,
        label:'None USA',
      }],
      searchInp:'',

      phoneNav: false, // mobile group dropdown
      bouns: false,//上下滑动 添加class
      scroll: 0,//上下滑动距离
      MunchiesShow: false,//一级导航显示
      search:false,//搜索框展示
      productName:'',//搜索绑定的值
      device: '',
      zipcode: '',
      cartX: null,
      cartY: null,
      delta: null,
      local: null,
      checkoutModal: false,
      showAccountPortal: false,
      userIconCoordinate: {
        right: 0,
        top: 0,
      },
      isMobile: isMobile,
      groupItemWarningLocal: false,
      groupLoginWarningLocal: false,

      addDisabled: false,
    }
  },
  methods: {
    ...mapActions("addresses", ["fetchMLMNetwork"]),
    ...mapActions('navbar',['fetchGroups']),
    ...mapActions('auth',['fetchCustomerInformation']),
    ...mapActions('cart',['addProductToCart']),
    ...mapActions('orders', ['fetchOrderByTimeFrame','fetchOrderDetails']),
    ...mapMutations('auth', ['logout', 'updateLoginStatus']),
    ...mapMutations('cart', ['resetAddToCartSuccess', 'closeCart', 'openCart', 'setGroupItemWarning', 'setGroupLoginWarning']), 
    ...mapMutations('navbar', ['updateSearchTerm', 'handleWindowResize', 'updateDevice', 'toggleModal', 'handleNavToAccountFromNavbar', 'mobileDevice']),
    ...mapMutations('products', ['updateActiveProduct', 'updateActiveQuantity']),
    ...mapMutations("checkout", ["updateIsShareCreditUsed"]),
    selectClassify(id){
      this.allGroups.forEach(item=>{
        if(item.ProductGroup_id == id){
          this.dataListsChild = item.Categories
        }
      })
      this.classright = true
    },
    handleMouseIn(event) {
      this.showAccountPortal = true;
    },
    handleCartMouseOver(e) {
      this.toggleCart();
    },
    handleWindowChange() {
      this.handleWindowResize({
        windowWidth: document.documentElement.clientWidth,
        windowHeight: document.documentElement.clientHeight,
      });
    },
    handleCartMouseOut(e) {
      const classNameArray = ['cart-container', 'flex-wrapper', 'table', 'thead-container', 'tr', 'th-title', 'thead-container', 'product-container', 'cart__image-wrapper', "table-image", "cart__meta small--text-left", 'product-name', 'unit-price', 'quantity-container', 'qty_input', 'button-wrap', 'decrement-btn', 'product-quantity', 'increment-btn', 'fa fa-trash-o', 'checkout-box', 'checkout-subtotal', 'checkout-tax', 'checkout-subtotal', 'empty-space', 'checkout-button-wrap', 'btn', 'nav', 'nav_phone_left hidden-md-and-up', 'logo', 'hidden-sm-and-down', 'nav-icon', "cart-title"];
      if(!e.relatedTarget){
        return;
      }
      if (classNameArray.includes(e.relatedTarget.className.split(' ')[0])) {
        return; 
      } else {
         setTimeout(() => {this.closeCart();}, 500);
      }
    },
    handleMouseOut(event) {
      const arrOfClassName = ["account-portal-modal","account-portal-modal-info", "speech-bubble", "arrow", "bubble-node"];
      if(!event.relatedTarget){
        return
      }
      if(arrOfClassName.includes(event.relatedTarget.className.split(' ')[0])) {
        return;
      }
      this.showAccountPortal = false;
    },
    navToAccount(target) {
      this.handleNavToAccountFromNavbar(target);
      if(this.$route.name !== 'account') {
        this.$router.push('/account');
      }
    },
    changeCoordinateOfModal() {
      this.userIconCoordinate = {
        right: 100 + 'px',
        top: document.getElementsByClassName('navusername')[0].getBoundingClientRect().y + 10 + 'px',
      };
    },
    cartDetailsModalChange() {
      this.cartX = document.getElementsByClassName('site-header__cart-count')[0].getBoundingClientRect().x  + 'px';
      this.cartY = document.getElementsByClassName('site-header__cart-count')[0].getBoundingClientRect().y + 'px';
    },
    bounsShow() {
      if (this.bouns) {
        document.getElementsByTagName("body")[0].className = "body_top";
      } else {
        document.getElementsByTagName("body")[0].className = "";
      }
    },
    handleScroll() {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (this.scroll > 0) {
        this.bouns = true;
        this.bounsShow()
      } else {
        this.bouns = false;
        this.bounsShow()
      }
    },
    //路由跳转 1 登录 2购物车
    active(num) {
      if (num == 1) {
        this.$router.push("/login");
      } else if (num == 2) {
        this.$router.push("/cart");
      } else if (num == 3) {
        this.$router.push("/purchase");
      }
    },
    //rediract screen
    mobileNavGo(id) {
      this.phoneNav = false;
      this.navGo(id)
    },
    navGo(id) {
      const group = this.dataListsChild.filter( group => group.ProductCategory_id === id)[0];
      if(this.$router.currentRoute.params && this.$router.currentRoute.params.group) {
        if(this.$router.currentRoute.params.group.toLowerCase() !== group.Name.toLowerCase()) {
          this.$router.push(`/collections/${group.Name.toLowerCase()}`)
        }else {
          this.$root.fetchSelectedGroup(group.ProductCategory_id, 'category');
        }
      }else {
        this.$router.push(`/collections/${group.Name.toLowerCase()}`)
      }
    },
    phoneNavShow() {
      this.phoneNav = !this.phoneNav;
    },
    searchShow(){
      this.search = !this.search
    },
    toggleCart() {
      if (this.windowWidth > 990) {
        this.$store.dispatch('cart/getCart')
        .then(() => {
          this.openCart();
        })
      } else if (this.windowWidth <= 990) {
        this.$router.push('/cart');
      }
    },
    //Sign out User
    signOut() {
      this.logout();
    },
    tokenIsValid() {
      //send token to server see if it is still valid
      return true
    },
    searchProduct(product) {
      this.$router.currentRoute.path !== "/search" && this.$router.push({ path: '/search', query: { product: this.searchInp}})
      this.updateSearchTerm(this.searchInp);
    },
    validateDeliveryRadius(event) {
      const inputValue = event.target.value;
      if ((!Number.isNaN(Number(inputValue))) || inputValue === '') {
      this.zipcode = inputValue;
      }
    },
    checkForClose(event) {
      if (event === undefined) {
        this.toggleModal(false);
        localStorage.setItem('showModalToken', false);
      }
    },
    deleteItem(item) {
      if (!this.itemDeletedLoading) {
        let productId = item.Product_id
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/deleteCartItem', item.Product_id)
          .then(() => {
            this.$store.dispatch('cart/getCart')
          });
        } else {
          const cartItems = _.filter(this.$store.state.cart.cartProductsList, item => item.Product_id !== productId);
          setLocalCart(cartItems);
          let itemCount = 0;
          cartItems.forEach((item) => {
            itemCount += item.quantity;
          });
          this.$store.dispatch('cart/updateItemQuantity', [productId, itemCount]);
          this.$store.dispatch('cart/fetchCartProducts');
        }
      }
    },
    updateItemCount(e, item) {
      e.preventDefault();
      if (isUserAuthenticated()) {
      let quantity = item.Quantity - 1;
      if (quantity < 1) {
          this.deleteItem(item)
          this.local = false;
        } else {
        this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
        .then(() => { 
          this.local = false;
          this.$store.dispatch('cart/getCart');
        });
        }
      } else {
        item.quantity = item.quantity - 1;
        if (item.quantity < 1) {
          this.deleteItem(item)
        }
        this.$store.dispatch('cart/updateLocalCart', item)
        .then(() => {
          this.local = true;
          this.$store.dispatch('cart/fetchCartProducts');
        })
      }
    },
    postCartItemsAndCheckout(e) {
      if(this.windowWidth<990){
        return
      }
      e.preventDefault();
      if (isUserAuthenticated()) {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
      cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
      this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
      .then(() => {
        this.closeCart();
        this.$router.push('/purchase');
      });
      } else {
        this.$router.push('/login');
      }
    },
    handleAddToCartSuccess(data) {
      this.$store.dispatch('cart/addCart', data.item)
      .then(() => { 
        this.$store.dispatch('cart/getCart');
      });
    },
    handleAddToCartFail(product) {
      alert(`Sorry, there are only ${product.StockLevel} available of ${product.Name}`);
    },
    throttleAddToCart:  _.debounce(function(item, event) {
      this.addDisabled = true;
      setTimeout(() => this.addDisabled = false, 1000);
      const isUSA = localStorage.getItem('isUSA');
      if (isUSA === true || isUSA === 'true') {
        this.addToCart(item);
      } else {
        const productCount = item.Quantity+1;
        const totalCount = this.itemCount+1;
        
        if (productCount > 7 || totalCount > 10) {
          alert(this.$t("noneUSAProductNote"));
        } else {
          this.addToCart(item);
        }
      }
    }, 150, {'leading': true, 'trailing': true}),
    addToCart: function(item) {
      // if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item, event: event})  
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item])      
        }
      // }
    },
    getPos(el) {
    for (var lx=0, ly=0;
      el != null;
      lx += el.offsetLeft, ly += el.offsetTop, el = el.offsetParent);
      this.cartX = lx;
      this.cartY = ly;
    },
    localTotalPrice(price, quantity) {
      return (price * quantity).toFixed(2);
    },
    calculateTotalCartQuantity() {
      let totalQuantity = 0;
      for (var i = 0; i < this.cartProductsList.Sales_Order_Lines.length; i++) {
        totalQuantity += this.cartProductsList.Sales_Order_Lines[i].Quantity;
      }
      return totalQuantity;
    },
    goToLogin() {
      this.closeCart();
      this.$router.push("/login");
    },
    calculateLocalSubtotal() {
      if (this.local) {
        let cost = 0;
        this.$store.state.cart.cartProductsList.map(item => {
          let itemPrice = item.Price * item.quantity;
          cost += itemPrice; 
        })
        return cost.toFixed(2);
      }
      return this.$store.state.cart.cartProductsList.TotalPrice.toFixed(2);
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({ 
        name: 'productDetails', 
        query: { productNum: product.ProductNum 
      }})
    },
    langChanged(lang){
      localStorage.Lang=lang;
    },
    locationChanged(e){
      localStorage.setItem('isUSA', e);
      this.$router.go(0);
    },
    goToCheckoutPage() {
      this.groupItemWarningLocal = false;
      this.$router.push('/purchase');
    },
    goToLoginPage() {
      this.groupLoginWarningLocal = false;
      this.$router.push('/login');
    },
    sharingClosed() {
      localStorage.setItem('shareCreditUsed', true);
      this.updateIsShareCreditUsed(true);
    },
    onClickShareWechat() {
      this.shareModalOpen = false;
      this.wechatModalOpen = true;
    },
  },
  beforeMount() {
    if (isUserAuthenticated()) {
      this.local = false;
      this.$store.dispatch('cart/getCart');
    } else {
      this.local = true;
      this.$store.dispatch('cart/fetchCartProducts');
    }
    if (window.screen.width < 900) {
      //WAP and ONLINE are what Yuansfer uses to distinguish between mobile
      //and desktop devices. 
      this.updateDevice('WAP');
    } else {
      this.updateDevice('ONLINE');
    }
    if (window.screen.width <= 500) {
      this.mobileDevice(true);
    } else {
      this.mobileDevice(false);
    }
    if (JSON.parse(localStorage.getItem('showModalToken')) !== true && JSON.parse(localStorage.getItem('showModalToken')) !== false) {
      localStorage.setItem('showModalToken', true);
    }
  },
  mounted() {
    if (this.userDetails && this.userDetails.mobile_user_id) {
      this.fetchMLMNetwork(this.userDetails.mobile_user_id);
    }
    let cart = document.getElementsByClassName('site-header__cart-count')[0];
    if(localStorage.getItem('token') && this.tokenIsValid(localStorage.getItem('token'))) {
      this.updateLoginStatus(true);
    };
    window.addEventListener('scroll', this.handleScroll, true);
    this.fetchGroups();
    if (this.$router.history.current.name !== 'purchase' && JSON.parse(localStorage.getItem('showModalToken')) === true) { 
      this.toggleModal(true);
    }
    this.$store.dispatch('auth/fetchCustomerInformation');
    this.getPos(cart);
    this.$store.dispatch('orders/fetchOrderByTimeFrame', 3);
    this.$nextTick(function() {
      this.changeCoordinateOfModal();
      this.handleWindowChange();
    })
    if(localStorage.Lang!=null) this.$i18n.locale=localStorage.Lang;
  },
  created() {
    window.addEventListener('resize', this.changeCoordinateOfModal);
    window.addEventListener('resize', this.handleWindowChange);
  },
  destroyed() {
    window.removeEventListener("resize", this.changeCoordinateOfModal);
    window.removeEventListener('resize', this.handleWindowChange);
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    itemCount: state => state.cart.itemCount,
    allGroups: state => state.navbar.allGroups,
    cartProducts: state => state.cart.cartProductsList,
    homeWithinRadius: state => state.navbar.homeWithinRadius,
    homeRadiusChecked: state => state.navbar.homeRadiusChecked,
    checkoutWithinRadius: state => state.navbar.checkoutWithinRadius,
    checkoutRadiusChecked: state => state.navbar.checkoutRadiusChecked,
    showModal: state => state.navbar.showModal,
    showModalToken: state => state.navbar.showModalToken,
    addToCartLoading: state => state.cart.addToCartLoading,
    addToCartSuccessful: state => state.cart.addToCartSuccessful,
    itemAdded: state => state.cart.itemAdded,
    cartClicked: state => state.cart.cartClicked,
    cartProductsList: state => state.cart.cartProductsList,
    token: state => state.auth.token,
    mobile: state => state.navbar.mobile,
    itemDeletedLoading: state => state.cart.itemDeletedLoading,
    itemDeleted: state => state.cart.itemDeleted,
    windowWidth: state => state.navbar.windowWidth,
    activeProduct: state => state.products.activeProduct,
    activeQuantity: state => state.products.activeQuantity,
    IsShareCreditUsed: (state) => state.checkout.IsShareCreditUsed,
    groupItemWarning: (state) => state.cart.groupItemWarning,
    groupLoginWarning: (state) => state.cart.groupLoginWarning,
    userDetails: (state) => state.auth.userDetails,
    networkData: (state) => state.addresses.networkData,
  }),
  watch: {
    wechatModalOpen: function (newVal, oldVal) {
      let that = this;
      if (newVal === true) {
        this.wechatTimeout = setTimeout(function() {
          localStorage.setItem('shareCreditUsed', true);
          that.updateIsShareCreditUsed(true);
        }, 5000);
      }
      if (newVal === false && this.wechatTimeout) {
        clearTimeout(this.wechatTimeout);
      }
    },
    loggedIn: function(newVal, oldVal) {
      immediate: true;
      if (oldVal === true && newVal === false) {
          this.$store.dispatch('cart/deleteLocalCart')
      } else if (oldVal === false && newVal === true) {
        this.cartProducts.map(localCartItem => {
          this.$store.dispatch('cart/addCart', localCartItem)
        });
      }
    },
    showModal: function(newVal, oldVal) {
      // this will cause the window cant scroll
      if (newVal === true) {
        document.documentElement.style.overflow = 'hidden';
        return;
      } else {
        document.documentElement.style.overflow = 'auto';
      }
    },
    token: function(newVal, oldVal) {
      immediate: true;
      if (newVal !== null || newVal !== undefined) {
        this.local = false;
        this.$store.dispatch('cart/getCart');
      } else {
        this.local = true;
        this.$store.dispatch('cart/fetchCartProducts');
      }
    },
    // no need this  duplicate call
    // itemCount: function(newVal, oldVal) {
    //   console.log('here');
    //   if (newVal !== oldVal) {
    //     if (isUserAuthenticated()) {
    //       this.$store.dispatch('cart/getCart');
    //     } else {
    //       this.$store.dispatch('cart/fetchCartProducts');
    //     }
    //   }
    // },
    addToCartSuccessful: function(newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        setTimeout(() => {
          this.resetAddToCartSuccess();
        }, 4000)
      }
    },
    	activeProduct: function(newVal, oldVal) {
      immediate: true;
      if (newVal !== oldVal ) {
        let quantFound = false;
        if (isUserAuthenticated() && this.cartProductsList && this.cartProductsList.Sales_Order_Lines) {
          this.cartProductsList.Sales_Order_Lines.map(item => {
            if (item.ProductNum === newVal) {
              quantFound = true;
              this.updateActiveQuantity(item.Quantity);
            }
          })
        } else {
          this.cartProductsList.map(item => {
            if (item.ProductNum === newVal) {
              quantFound = true;
              this.updateActiveQuantity(item.quantity);
            }
          })
        }
        if (!quantFound) {
          this.updateActiveQuantity(0);
        }
      }
    },  
    groupItemWarning: function (newVal, oldVal) {
        if (newVal === true) {
          this.groupItemWarningLocal = true;
          this.setGroupItemWarning(false);
        }
    },
    groupLoginWarning: function (newVal, oldVal) {
        if (newVal === true) {
          this.groupLoginWarningLocal = true;
          this.setGroupLoginWarning(false);
        }
    },
    networkData: function (newVal, oldVal) {
      if (newVal && newVal[0]) {
        this.config['url'] = "https://www.newbiotechcorp.com/home/" + newVal[0].id;
        this.sharing['url'] = "https://www.newbiotechcorp.com/home/" + newVal[0].id;
      }
    },
    userDetails: function (newVal, oldVal) {
      if (newVal && newVal.mobile_user_id) {
        this.fetchMLMNetwork(newVal.mobile_user_id);
      }
    },
  }
}
</script>

<style lang="less" scope>
@import "../assets/css/modal.less";
@import "../assets/css/navbar.less";
@import "../assets/css/public.less";
@import "../assets/css/cartContainer.less"; 

.unroll-enter-active, .unroll-leave-active {
  transition: opacity .5s;
}
.unroll-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.unroll-enter, .unroll-leave-to {
  opacity: 0;
}
.account-portal-modal {
  position: absolute;
  z-index: 7;
  padding-top: 20px;
  cursor: pointer;
}
.account-portal-modal-info{
  background-color: #F5F5F5;
  border-radius: 5px;
  width: 200px;
  // height: 270px;
  text-align: center;
  // padding: 20px;
  padding-top: 0;
  // position: absolute;
  box-shadow: 1px 10px 15px rgba(0, 0, 0, 0.2);
  // z-index: 7;
  padding: 20px;
  padding-top: 0;
}

.modal-data-container {
  display: block;
  text-align: left;
  // padding: 20px;

  .usernameDisplayInBuble {
    color: grey;
    cursor: pointer;
    padding: 12px 0;
    font-size: 70%
  }

  .portal-links-container {
    padding: 20px 0;
    .each-link {
      line-height: 30px;
      cursor: pointer;
    }
  }

  .logout {
    cursor: pointer;
    width: 100%;
    height: 30px;
    line-height: 30px;
    background-color: #29327F;
    border-radius: 10px;
    text-align: center;
    color: #fff;
  }
}

.prevent{
  width: 100%;
  height: 30px;
  background-color: transparent;
  position: absolute;
  top: -30px;
  left: 0;
}
.arrow {
  position: inherit;
  border-style: dashed;
  border-color: transparent;
  border-width: 0.20em;
  display: -moz-inline-box;
  display: inline-block;
  /* Use font-size to control the size of the arrow. */
  font-size: 50px;
  height: 0;
  line-height: 0;
  position: relative;
  vertical-align: middle;
  width: 0;
  background-color:transparent; /* change background color acc to bg color */ 
  border-bottom-width: 0.2em;
  border-bottom-style: solid;
  border-bottom-color: #f8f8f8;
  bottom:0.25em;
  top: -23px;
  left: 50px;
  z-index: inherit;
}

// .v-modal {
//   z-index: 0 !important;
// }
// .ui-select{width: 100%;}
// select::-ms-expand {	display: none; }
// select{
//     -webkit-appearance: none;
//     appearance: none;
// }
// @-moz-document url-prefix(){
// 	.ui-select{border: 1px solid #CCC; border-radius: 4px; box-sizing: border-box; position: relative; overflow: hidden;}
//   .ui-select select { width: 110%; background-position: right 30px center !important; border: none !important;}
// }
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue